import React, { useReducer } from "react";
// import { isBrowser } from "./util";

export const Context = React.createContext();
export const TOGGLE_THEME = "toggle_theme";
export const TOGGLE_MENU = "toggle_menu";

// const getSavedTheme = () => {
//   let savedTheme = "dark";
//   if (isBrowser) {
//     savedTheme = window.localStorage.getItem("ee-docs-theme");
//   }
//   return savedTheme;
// };

const initialValue = {
  theme: "dark",
  menuOpen: false
};

const reducer = (state, action) => {
  switch (action.type) {
    case TOGGLE_THEME:
      const theme = state.theme === "light" ? "dark" : "light";
      window.localStorage.setItem("ee-docs-theme", theme);
      return { ...state, theme };
    case TOGGLE_MENU:
      return { ...state, menuOpen: !state.menuOpen };
    default:
      return state;
  }
};

const ContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialValue);
  return (
    <Context.Provider value={{ state, dispatch }}>{children}</Context.Provider>
  );
};

export default ContextProvider;
